import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-denuncias',
  templateUrl: './denuncias.component.html',
  styleUrls: ['./denuncias.component.css']
})
export class DenunciasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
